import { Component, inject, Input, signal } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { IContenEntity } from '@web-nx-ng-tsc/web-shared-data-access';

@Component({
  selector: 'lib-web-shared-ui-lib-product-content-card',
  imports: [],
  templateUrl: './lib-product-content-card.component.html',
  styleUrl: './lib-product-content-card.component.scss',
})
export class LibProductContentCardComponent {
  // inject
  private readonly sanitizer = inject(DomSanitizer);

  @Input() set data(value: IContenEntity) {
    this.dataSignal.set(value);
  }

  dataSignal = signal<IContenEntity>({} as IContenEntity);

  sanitizedContent(content: any) {
    return this.sanitizer.bypassSecurityTrustHtml(content);
  }
}
